<div [formGroup]="formGroup">
  <sc-flex [gap]="8">
    <sc-date-field formControlName="dateFrom"
      [label]="'' | translate:['tmc-yard.control.entity.transport-option-limits-schedule.dateFrom', translationService.language]"></sc-date-field>
    <sc-date-field formControlName="dateUntil"
      [label]="'' | translate:['tmc-yard.control.entity.transport-option-limits-schedule.dateUntil', translationService.language]"></sc-date-field>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-action-icon iconClass="fa-trash-circle fa-2x" (click)="removeLimitExceptionSchedule()"></sc-action-icon>
  </sc-flex>
  <sc-content-spacer half vertical></sc-content-spacer>
  <sc-flex [gap]="8">
    <sc-number-field class="dayField"
      formControlName="limitMonday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitMonday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitTuesday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitTuesday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitWednesday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitWednesday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitThursday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitThursday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitFriday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitFriday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitSaturday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitSaturday"></sc-number-field>
    <sc-number-field class="dayField"
      formControlName="limitSunday"
      labelDictionaryKey="tmc-yard.control.entity.transport-option-limits-exception-schedule.limitSunday"></sc-number-field>
  </sc-flex>
</div>
